import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import { IconButton as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as Up } from '../../images/icons/up.svg';

interface IProps extends StyledComponentProps {
    onClick: (e) => any;
    disabled?: boolean;
}

const CollapseUpButton = (props: IProps) => {
    return (<MuiButton
        disabled={props.disabled}
        className={props.classes.listIconButtonRootSvg}
        onClick={props.onClick}>
            <Up className={props.classes.listIconButtonSvg}/>
    </MuiButton>)
}


export default withStyles(styles)(CollapseUpButton)